import { render, staticRenderFns } from "./InfosMediaList.vue?vue&type=template&id=04c968b2&scoped=true"
import script from "./InfosMediaList.vue?vue&type=script&lang=js"
export * from "./InfosMediaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c968b2",
  null
  
)

export default component.exports